import { Directive, HostBinding, HostListener, inject, Input, signal } from '@angular/core';
import { finalize, map } from 'rxjs';
import { CollaborationAttachmentsDataService } from '@ffd/api-client';
import { Dialog } from '@angular/cdk/dialog';
import { HttpContext } from '@angular/common/http';
import { DISABLE_GLOBAL_ERROR_TOASTS } from '@libs/utils';
import { TutorialModule } from 'libs/onboarding/src/lib/onboarding-modal/onboarding-videos';
import { PreviewAttachmentDialogComponent, PreviewVideoAttachmentDialogData } from '../../attachment-preview-dialog';

@Directive({
  selector: '[libPreviewVideo]',
  standalone: false,
})
export class PreviewVideoDirective {
  private readonly dataService = inject(CollaborationAttachmentsDataService);
  private readonly dialog = inject(Dialog);

  public isThumbnailClickable = signal(true);

  @Input() public fileId?: string;
  @Input() public file?: File;
  @Input() public videoUrl?: string;
  @Input() public fileType!: string;
  @Input() public thumbnailUrl!: string;
  @Input() public showPreview = true;
  @Input() public tutorialModule?: TutorialModule;
  @Input() public installationContractId?: string;

  @HostListener('click', ['$event']) public open(event: MouseEvent): void {
    event.preventDefault();
    if (!this.showPreview) {
      return;
    }

    if (!this.isThumbnailClickable()) return;

    if (this.videoUrl) {
      this.openPreviewModal(this.videoUrl);
    } else if (this.fileId) {
      this.isThumbnailClickable.set(false);

      this.dataService
        .getDownloadLinkForAttachment(this.fileId, undefined, undefined, {
          context: new HttpContext().set(DISABLE_GLOBAL_ERROR_TOASTS, true),
        })
        .pipe(
          map((link) => link.url),
          finalize(() => this.isThumbnailClickable.set(true)),
        )
        .subscribe((url) => {
          this.openPreviewModal(url);
        });
    } else {
      console.error('No fileId or videoUrl is found');
    }
  }

  @HostBinding('class') public cursorBinding = 'cursor-pointer';

  private openPreviewModal(url: string) {
    this.dialog.open<PreviewAttachmentDialogComponent, PreviewVideoAttachmentDialogData>(PreviewAttachmentDialogComponent, {
      hasBackdrop: true,
      backdropClass: ['bg-overlay-light', 'backdrop-blur', 'collab-video-backdrop'],
      panelClass: ['video-preview-dialog'],
      data: {
        type: 'video',
        id: this.fileId,
        file: this.file,
        autoplay: true,
        fileData: {
          videoUrl: url,
          fileType: this.fileType,
          thumbnailUrl: this.thumbnailUrl,
        },
        tutorialModule: this.tutorialModule,
        installationContractId: this.installationContractId,
      },
    });
  }
}
